import styled from '@emotion/styled'
import React from 'react'
import { dimensions, media } from '../style/variables'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

const Container = styled.a`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	position: relative;
	justify-content: center;
	border-radius: 2px;
	background-color: white;
	border-radius: 3px;
	box-shadow: 0 2px 20px 0 rgba(87, 82, 82, 0.16);
	transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
	cursor: pointer;
	text-decoration: none;
	margin: 0 -3px;
	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 0px 20px rgb(0 0 0 / 25%), 0 7px 10px rgb(0 0 0 / 22%);
		text-decoration: none;
	}
	&:active {
		transform: translateY(0px);
		box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.07);
	}
`
const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 30px 20px;
	flex: 1 1 55%;
	z-index: 100;
	${media.down('xs')} {
		padding: 10px 20px;
	}
`
const StyledSpan = styled.span`
	color: rgb(var(--clr-primary));
	padding-bottom: 5px;
	font-size: 1rem;
	font-weight: 600;
	color: #323232;
	${media.up('md')} {
		font-size: 1.1rem;
	}
`
const StyledH3 = styled.h2`
	color: #101010;
	margin-bottom: 0;
	font-size: 1.4rem;
	${media.up('md')} {
		font-size: 24px;
		font-size: 2rem;
	}
`
const FakeButton = styled.span`
	margin-top: 30px;
	color: white;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	user-select: none;
	outline: 0;
	border: ${dimensions.borderWidth}px solid;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15ms ease-in-out,
		box-shadow 0.15s ease-in-out;
	font-weight: bold;
	font-size: ${dimensions.fontSize.regular}rem;
	line-height: ${dimensions.lineHeight.regular};
	padding: 0.375rem 0.75rem;
	border-radius: 50px;
	opacity: 1;
	background-color: rgb(var(--clr-primary));
	border-color: rgb(var(--clr-primary));
	${media.down('xs')} {
		margin-top: 5px;
	}
`

const StyledImg = styled(Img)`
	display: block;
	color: white;
	position: relative;
	object-fit: cover;
	flex: 1 1 45%;
	border-bottom-right-radius: 3px;
	border-top-right-radius: 3px;
	${media.down('xs')} {
		display: none;
	}
	&:after {
		content: '';
		position: absolute;
		display: block;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: linear-gradient(
			to right,
			#ffffff 3%,
			rgba(252, 251, 250, 0.804) 18%,
			rgba(250, 240, 220, 0) 100%
		);
	}
`

export type CardProps = {
	href?: string
}

export default function ParticipateCard(props: CardProps) {
	const { href } = props
	const data = useStaticQuery(graphql`
		query {
			file(relativePath: { eq: "noodles.jpg" }) {
				childImageSharp {
					fluid {
						...GatsbyImageSharpFluid
					}
				}
			}
		}
	`)
	return (
		<Container href={href} aria-label="Linkki etusivulle">
			<TextWrapper>
				<StyledSpan>Haluatko yli 200 herkullista reseptiä?</StyledSpan>
				<StyledH3>31 päivää ilmaisia vinkkejä vegempään elämään</StyledH3>
				<FakeButton>Ilmoittaudu mukaan Vegaanihaasteeseen!</FakeButton>
			</TextWrapper>
			<StyledImg fluid={data.file.childImageSharp.fluid} alt="noodles" />
		</Container>
	)
}
